// extracted by mini-css-extract-plugin
export default {"TwoDimsListFeature":"wi_a bhs_b","TwoDimsListFeature__item":"wi_b bhs_we","TwoDimsListFeature__item__text":"wi_c bhs_vt"};